import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { OrderHistory } from '../../core/api/order/order.types';
import { DeliveryType } from '../../core/api/restaurant/restaurant.types';
import { loadMenu } from '../../core/state/menu/menuMiddleware';
import { Basket } from '../../core/state/order/order.types';
import {
  setReorderOrderId,
  setUnavailableReorderItems,
} from '../../core/state/order/orderActions';
import { loadOrderHistory } from '../../core/state/order/orderMiddleware';
import { loadRestaurantDetail } from '../../core/state/restaurant/restaurantMiddleware';
import { selectRestaurantDetails } from '../../core/state/restaurant/restaurantSelectors';
import { selectAppConfig } from '../../core/state/whitelabel/whitelabelSelectors';
import { OrderType } from '../../core/types/route.types';
import { getUtils } from '../../utils';
import { setBasket } from '../../weborder/redux/basket/actions';
import { menuSelectors } from '../../weborder/selectors';
import * as Store from '../../weborder/Store';
import { OrderHistoryDetail as RedesignOrderHistoryDetail } from './OrderHistoryDetail';

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;
export type StateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: Store.State) => {
  const { orders } = state;
  const { orderId } = state.location.params;

  const currentLang = getUtils.activeLanguageCode(state.locale.languages);

  let orderDetails: OrderHistory;
  if (orders.history.status === 'success') {
    orderDetails = orders.history.data.find(
      (item) => item.OrderId === Number(orderId),
    );
  }

  const deliveryType =
    orderDetails?.DeliveryType === DeliveryType.Delivery
      ? OrderType.DELIVERY
      : OrderType.COLLECTION;

  const restaurantDetail = selectRestaurantDetails(state, {
    deliveryType,
    vrId: orderDetails?.VirtualRestaurantId,
    prId: orderDetails?.PhysicalRestaurantId,
    deliveryLocationId: orderDetails?.DeliveryLocationId,
  });
  const menuUrl = restaurantDetail?.MenuUrl;
  const menu = menuSelectors.findMenuByUrl(state, { menuUrl });
  const deliveryLocations =
    orderDetails?.DeliveryType === DeliveryType.Delivery
      ? state.deliveryOptions
      : undefined;

  return {
    appConfig: selectAppConfig(state),
    collectionRestaurants: state.collectionRestaurants,
    currentLang,
    deliveryLocations,
    deliveryRestaurants: state.deliveryRestaurants,
    menu,
    menuUrl,
    orderDetails,
    orderHistory: state.orders.history,
    orderId: Number(orderId),
    restaurantDetail,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  actions: {
    loadMenu: (menuUrl: string): void => {
      dispatch(loadMenu(menuUrl));
    },
    loadOrderHistory: (): void => {
      dispatch(loadOrderHistory());
    },
    loadRestaurantDetail: (
      vrId: number,
      orderType: OrderType,
      id: number,
    ): void => {
      dispatch(loadRestaurantDetail(vrId, orderType, id));
    },
    setBasket: (payload: Basket): void => {
      dispatch(setBasket(payload));
    },
    setReorderOrderId: (orderId: number): void => {
      dispatch(setReorderOrderId(orderId));
    },
    setUnavailableReorderItems: (items: string[]): void => {
      dispatch(setUnavailableReorderItems(items));
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RedesignOrderHistoryDetail);
